import React, { useState, useEffect,  useMemo, useRef} from 'react';
import './assets/releaseSummary.css';
import HamburgerIcon from './assets/HamburgerIcon.svg'
import { Button, DatePicker, Form, Input, Radio, Select, TimePicker} from 'antd';
import moment from 'moment';
import Loader from '../common/Loader'
import PopupIcon from './assets/popup-icon-16.png'
import NewTable from '../common/NewTable'
import QueryDisplayer from '../slowQuery/QueryDisplayer'
import SearchIcon from './assets/search.svg'
import ReleaseSuccessCell from './releaseSuccessCell'
import ReleaseFailureCell from './releaseFailureCell'
import ReleaseJiras from './releaseJiras'
import ExportIcon from './assets/export.svg'
import * as XLSX from 'xlsx';


function ReleaseSummary(props) {

	const [active, isActive] = useState(true)

	const [form] = Form.useForm();

	const searchRef = useRef(null);

	const { Search } = Input;

	const [hiddenColumns, setHiddenColumns] = useState([])

	const [mysqlFilters, setMysqlFilters] = useState({})

	const [loadData, setLoadData] = useState(false)

	const [releaseStatus, setReleaseStatus] = useState('')

	const [selectedDBType, setSelectedDBType] = useState('Mysql')

	const [showForm, setShowForm] = useState(false)

	const [allowedMonths, setAllowedMonths] = useState([])

	const [selectedMonth, setSelectedMonth] = useState()

	const [selectedOriginalMonth, setSelectedOriginalMonth] = useState()

	const [showTable, setShowTable] = useState(false)

	const [selectedJira, setSelectedJira] = useState('')

	const [selectedStatus, setSelectedStatus] = useState('')

	const [disableStatus, setDisableStatus] = useState(true)

	const [disableRelease, setDisableRelease] = useState(true)

	const [tableColumns, setTableColumns] = useState([])

	const [dbOptions, setDBOptions] = useState([])

	const [releaseOptions, setReleaseOptions] = useState([])

	const [envOptions, setEnvOptions ] = useState([])

	const [statusOptions, setStatusOptions] = useState([])

	const [selectedRelease, setSelectedRelease] = useState('')

	const [disableJira, setDisableJira] = useState(true)

	const [showReportDisable, setShowReportDisable] = useState(true)

	const [totalCount, setTotalCount] = useState(0)

	const [failedCount, setFailedCount] = useState(0)

	const [successCount, setSuccessCount] = useState(0)

	const [progressCount, setProgressCount] = useState(0)

	const [executeCount, setExecuteCount] = useState(0)

	const [slowQueryData, setSlowQueryData] = useState([])

	const [jiraOptions, setJiraOptions] = useState([])

	const [filters, setFilters] = useState({})

	const [searchValue, setSearchValue] = useState('')

	const [showSearch, setShowSearch] = useState(false)

	const [originalData, setOriginalData] = useState([])

	const [selectedData, setSelectedData] = useState({})

	const [showData, setShowData] = useState(false)


	const mongoColumns = useMemo(
		() => [
			{
				Header : "Jira",
				accessor : "jira_name",
				width : 900
			},
			{
				Header : <div className="App-body-RS-Right-Cell">Total</div>,
				accessor : "total",
				width : 300,
				Cell : row => (
					<div className="App-body-RS-Right-Cell">
						{row.row.original.total? row.row.original.total : 0 }
					</div>
				)
			},
			{
				Header : <div className="App-body-RS-Right-Cell">Success</div>,
				accessor : "Success",
				width : 200,
				Cell : row => (
					<div className="App-body-RS-Right-Cell">
						{row.row.original.Success? <ReleaseSuccessCell  handleClick={handleSuccessClick} data={row.row.original} /> : 0 }
					</div>
				)
			},
			{
				Header : <div className="App-body-RS-Right-Cell">Failed</div>,
				accessor : "Failed",
				width : 200,
				Cell : row => (
					<div className="App-body-RS-Right-Cell">
						{row.row.original.Failed? <ReleaseFailureCell handleClick={handleFailureClick} data={row.row.original} /> : 0 }
					</div>
				)
			},
			{
				Header : <div className="App-body-RS-Right-Cell">In Progress</div>,
				accessor : "Initiated",
				width : 200,
				Cell : row => (
					<div className="App-body-RS-Right-Cell">
						{row.row.original.Initiated? row.row.original.Initiated : 0 }
					</div>
				)
			},
			{
				Header : <div className="App-body-CSum-Right-Cell">To Be Executed | Missed</div>,
				accessor : "To_be_executed",
				width : 200,
				Cell : row => (
					<div className="App-body-RS-Right-Cell">
						{row.row.original.To_be_executed? <div className="App-RS-To-Be-Executed"> {row.row.original.To_be_executed} </div> : 0 }
					</div>
				)
			},
		], [])

	const onSearch = (input) => globalSearch(input);

	function handleSuccessClick(data) {
		setReleaseStatus('success')
		setSelectedStatus('success')
		setSelectedData(data)
		setShowData(true)
	}

	function handleFailureClick(data) {
		setReleaseStatus('Failed')
		setSelectedStatus('failure')
		setSelectedData(data)
		setShowData(true)
	}

	useEffect(() => {
		populateMysqlFilter()
	}, [])


	function handleClose() {
		setSelectedData({})
		setShowData(false)
	}

	function globalSearch(input)  {
  		setSearchValue(input)
	    let searchInput = input;
	    if (searchInput == "") {
	    	setSlowQueryData(originalData)
	    	setShowSearch(false)
	    } else {
	    	let filteredData = originalData.filter(value => {
	      	return (
	        	value.jira_name &&  value.jira_name.toLowerCase().includes(searchInput.toLowerCase()) 
	      		);
	    	});
	    	setSlowQueryData(filteredData);
			}
  	};

  	function translateDateArray(inputArray) {
	    return inputArray.map(item => {
	        
	        return translateDate(item);
	    });
	}

	function translateDate(inputDate) {
		const parts = inputDate.split('-');
        // Assuming the format is always "MM-YYYY"
        const year = parts[1];
        const month = parts[0];

        return `${year}-${month}`;
	}
 
	useEffect(() => {
		if(showForm) {
				setFilters(mysqlFilters)
				var available_months = Object.keys(mysqlFilters)
				var translated_months = translateDateArray(available_months)
				setAllowedMonths(translateDateArray(available_months))
				setSelectedOriginalMonth(translated_months[0] + '-01')
				setSelectedMonth(available_months[0])
				setReleaseOptions(constructFilterArray(Object.keys(mysqlFilters[available_months[0]])))
				setDisableRelease(false)
				setTableColumns( mongoColumns )
				setShowTable(true)
		}

	}, [showForm])

	useEffect(() => {
		
		if (loadData) {
			var apikey = localStorage.getItem('db_portal_app_apikey')
	   		var oauth_token = localStorage.getItem('db_portal_oauth_token')
		    const doFetch = async () => {
		      const response = await fetch(BASE_URL + "/v1/release/releaseStatusSummary?release_name=" + selectedRelease,
	  		  	{
			      method : 'GET',	
			      headers : {
			        'x-api-key' : apikey,
			        'oauth-token' : oauth_token
			     }
		    })
		    const body = await response.json()
		    const result = body.message
		    setOriginalData(result['release_status_summary'])
		    setSlowQueryData(result['release_status_summary'])
		    calculateTotals(result['release_status_summary'])
		    setShowTable(true)
		    setLoadData(false)
		  }
		  doFetch()
		}
	}, [loadData])


	function calculateTotals(statusList) {
		let totalSum = 0;
    	let failedSum = 0;
    	let successSum = 0;
    	let progressSum = 0;
    	let executeSum = 0;

    	statusList.forEach(item => {
        	totalSum += item.total ? item.total : 0;
        	failedSum += item.Failed ? item.Failed : 0;
        	successSum += item.Success ? item.Success : 0;
        	progressSum += item.Initiated ? item.Initiated : 0;
        	executeSum += item.To_be_executed ? item.To_be_executed : 0;
    	});

    	setTotalCount(totalSum)
    	setSuccessCount(successSum)
		setFailedCount(failedSum)
		setProgressCount(progressSum)
		setExecuteCount(executeSum)
	}


	function parseResult(releaseList) {
		const transformed = releaseList.map(item => {
	        const jiraName = Object.keys(item)[0];
	        const statusCounts = item[jiraName];

	        return {
	            jira_name: jiraName,
	            total: statusCounts.total,
	            initiated: statusCounts.Initiated,
	            failed: statusCounts.Failed,
	            success: statusCounts.Success 
	        };
    	});
    	return transformed
	}


	const BASE_URL = process.env.REACT_APP_BASE_URL;

	function populateMysqlFilter() {
		var apikey = localStorage.getItem('db_portal_app_apikey')
	   	var oauth_token = localStorage.getItem('db_portal_oauth_token')
		const doFetch = async () => {
		      const response = await fetch(BASE_URL + "/v1/release/releaseStatusFilter"
  		      	, {
		      method : 'GET',
		      headers : {
		        'x-api-key' : apikey,
		        'oauth-token' : oauth_token
		      }
		    })
		    const body = await response.json()
		    const result = body.message
		    setMysqlFilters(result)
		    setShowForm(true)
		}
		doFetch()
	}


	function handleReleaseChange(fieldLabel, fieldValue) {
		setSelectedRelease(fieldLabel)
		var available_jiras = Object.keys(filters[selectedMonth][fieldLabel])
		setJiraOptions(constructFilterArray(available_jiras))
		setSelectedJira('')
		setSelectedStatus('')
		setShowReportDisable(false)
		setDisableJira(false)
		setDisableStatus(true)
	}

	function handleJiraChange(fieldLabel, fieldValue) {
		setSelectedJira(fieldLabel)
		var available_statuses = filters[selectedMonth][selectedRelease][fieldLabel]
		setStatusOptions(constructFilterArray(available_statuses))
		setSelectedStatus('')
		setShowReportDisable(true)
		setDisableStatus(false)
	}

	function handleStatusChange(fieldLabel, fieldValue) {
		setSelectedStatus(fieldLabel)
		setShowReportDisable(false)
	}

	function constructFilterArray(values) {
  		var resultArray = []
  		for (var index in values) {
  			var value = values[index]
  			var result = {}
  			result['value'] = value
  			result['label'] = value
  			resultArray.push(result)
  		}
  		return resultArray.sort((a, b) => a.value.localeCompare(b.value))
  	}

  	function handleMonthChange(date, dateString) {
  		setSelectedOriginalMonth(dateString + "-01")
  		var translatedDate = translateDate(dateString)
  		setSelectedMonth(translatedDate)
  		setReleaseOptions(constructFilterArray(Object.keys(filters[translatedDate])))
  		setSelectedRelease('')
		setSelectedStatus('')
		setShowReportDisable(true)
		setDisableRelease(false)
		setDisableJira(true)
		setDisableStatus(true)
  	}
 
	function handleButtonClick(){
		setTableColumns(mongoColumns)
		if (!loadData) {
			setSlowQueryData([])
			setShowTable(false)
			setLoadData(true)
		}
	}

	function constructFilterArray(values) {
  		var resultArray = []
  		for (var index in values) {
  			var value = values[index]
  			var result = {}
  			result['value'] = value
  			result['label'] = value
  			resultArray.push(result)
  		}
  		return resultArray.sort((a, b) => a.value.localeCompare(b.value))
  	}

  	function handleExportClick() {
		console.log("Export icon is clicked")
		var combinedQuery = []
		combinedQuery.push({'title' : 'Release Summary', jsonData : slowQueryData})
		convertJSONsToXLSX(combinedQuery)
	}

	function convertJSONsToXLSX(dataSets) {
        if (!dataSets || dataSets.length === 0) {
            console.error("No JSON data provided.");
            return;
        }

        const workbook = XLSX.utils.book_new();

        dataSets.forEach((dataSet, index) => {
            const ws = XLSX.utils.json_to_sheet(dataSet.jsonData);
            XLSX.utils.book_append_sheet(workbook, ws, dataSet.title || `Sheet${index + 1}`);
        });

        XLSX.writeFile(workbook, "release_summary.xlsx");
    };

  	function handleReset() {
		setSelectedDBType('Mongo')
		setSelectedRelease('')
		setSelectedMonth()
		setSelectedOriginalMonth()
		setDisableJira(true)
		setDisableRelease(true)
		setFilters(mysqlFilters)
		setShowReportDisable(true)
		setSlowQueryData([])
	}

	function handleShowSearch() {
  		setShowSearch(true)
  		
  		searchRef.current.focus({
      	cursor: 'start',
      })
  	}

  	const isDateAllowed = (date) => {
    	return allowedMonths.some(month => {
      		const startOfMonth = moment(month).startOf('month');
      		const endOfMonth = moment(month).endOf('month');
      		return date.isSameOrAfter(startOfMonth) && date.isSameOrBefore(endOfMonth);
    	});
 	 };

  	// Function to disable dates that are not allowed
  	const disableDate = (current) => {
    	// Do not disable dates if current is not a moment date object
    	if (!current || !moment.isMoment(current)) {
     		 return false;
    	}

    	return !isDateAllowed(current);
  	};


	return(
			<div className="App-RS-tab-container">
				<div className="App-body-RS-Header-Container">
					<div className="App-body-RS-Header-Title-Container">
						<div className="App-body-RS-Header-Title">
							<div className="App-body-RS-Header-Title-Hamburger">
								<img src={HamburgerIcon} />
							</div>
							<div className="App-body-RS-Header-Title-Name">
								Release Summary
							</div>
						</div>
					</div>
				</div>
				{showForm && showTable ?
				<div className="App-RS-tab-body">
					<div className="App-RS-tab-mongo-container">
						<div className="App-RS-tab-mongo-filter">		
									<div className="App-RS-tab-mongo-form">
									{showForm ? 
										<div className="App-RS-tab-mongo-filter-form">
											<Form
				      							form={form}
				      							layout="vertical"
				      						>
				      							<div className="RS-inline">
				      								<Form.Item label="Release Time" style={{width : '15%', margin:'1em 2em'}}>
				      									<DatePicker value={moment(selectedOriginalMonth)} picker="month" disabledDate={disableDate} onChange={handleMonthChange}/>
					      							</Form.Item>
					      							<Form.Item label="Release Name" style={{width : '25%', margin:'1em 2em'}}>
					        							<Select disabled={disableRelease} options={releaseOptions} value={selectedRelease} onChange={handleReleaseChange} />
					      							</Form.Item>
					      							<Button
					      							 	disabled={showReportDisable}
							            				type='primary'
							            				onClick={handleButtonClick}
							            				style={{margin : '3em 2em'}}
							              			>
				              							Show Report
				            						</Button>
				            						<Button
				            							onClick={handleReset}
				            							style={{ margin : '3em 1em'}}
				            						>
				            							Reset
				            						</Button>	      							
				      							</div>
				      						</Form>
										</div>
									: 
										<div className="App-SQ-tab-form-loader">
			      							<Loader />
			      						</div>
									}
									</div>

						</div>
						<div className="App-RS-tab-mongo-data-container">
							<div className="App-RS-tab-body-table-header-container">
								<div className="App-RS-table-container-count-box">
									<div className="App-RS-table-container-count"> Total : {totalCount} </div>
									<div>| </div>
									<div className="App-RS-table-container-count"> Success : {successCount}</div>
									<div>| </div>
									<div className="App-RS-table-container-count"> In Progress : {progressCount}</div>
									<div>| </div>
									<div className="App-RS-Exec-table-container-count"> To Be Executed / Missed : {executeCount}</div>
									<div>| </div>
									<div className="App-RS-table-container-count"> Error : {failedCount}</div>
								</div>
								<div className="App-RS-table-container-search-box">
									<div className="App-body-RS-header-export">
										<img src={ExportIcon} onClick={handleExportClick} />
									</div>
									{!showSearch && <img src={SearchIcon} onClick={handleShowSearch} /> }
    								{showSearch && <Search autoFocus placeholder="input search text" allowClear={true} onSearch={onSearch} style={{ width: 400 }} /> }
    							</div>
    						</div>
							{showTable ?
								<div className="App-RS-tab-body-table-container">
									<NewTable data={slowQueryData} columns={tableColumns} hiddenColumns={hiddenColumns} />
								</div>
							: 
								<div className="App-RS-tab-body-table-loader">
									<Loader />
								</div> 
							}
						</div>
					</div>				
				</div>
				: 
				 <div className="App-SQ-tab-form-loader">
				 	<Loader />
				 </div>
				}
				{showData ? <ReleaseJiras data={selectedData} releaseName={selectedRelease} releaseStatus={releaseStatus} handleClose={handleClose} /> : <div></div>}

			</div>
		)

}

export default ReleaseSummary